<template>
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    overflow="visible"
    preserveAspectRatio="none"
    viewBox="0 0 26 26"
    height="20"
    width="20"
  >
    <g transform="translate(1, 1)">
      <title>icon/misc/addpeople</title>
      <g
        fill-rule="evenodd"
        fill="none"
        stroke-width="1"
        stroke="none"
        id="icon/misc/addpeople"
      >
        <path
          :fill="color"
          id="Combined-Shape"
          d="M6.11929702,14.1671432 C8.35812192,12.4809044 11.5548576,12.158223 14.2065233,13.360869 C14.4580089,13.4749287 14.5694146,13.7712617 14.4553549,14.0227473 C14.3412953,14.2742329 14.0449623,14.3856386 13.7934767,14.2715789 C11.4718561,13.2186227 8.66458805,13.5019909 6.72092161,14.9659222 C5.61216678,15.8010145 4.63438533,17.5990172 3.8260733,20.3594884 C3.81270895,20.405129 3.80592424,20.4524429 3.80592424,20.5 C3.80592424,20.7761477 4.02978383,21.0000056 4.30593541,21 L4.30593541,21 L13,21 C13.2761424,21 13.5,21.2238576 13.5,21.5 C13.5,21.7761424 13.2761424,22 13,22 L13,22 L4.30594552,22 C3.4775086,22 2.80592424,21.3284376 2.80592424,20.5 C2.80592424,20.3573309 2.82627805,20.2153913 2.86637051,20.0784714 C3.7296583,17.1302522 4.80113513,15.1599568 6.11929702,14.1671432 Z M17.5,13 C17.7761424,13 18,13.2238576 18,13.5 L18,13.5 L17.9999242,16.5 L21,16.5 C21.2454599,16.5 21.4496084,16.6768752 21.4919443,16.9101244 L21.5,17 C21.5,17.2761424 21.2761424,17.5 21,17.5 L21,17.5 L17.9999242,17.5 L18,20.5 C18,20.7454599 17.8231248,20.9496084 17.5898756,20.9919443 L17.5,21 C17.2238576,21 17,20.7761424 17,20.5 L17,20.5 L16.9999242,17.5 L14,17.5 C13.7545401,17.5 13.5503916,17.3231248 13.5080557,17.0898756 L13.5,17 C13.5,16.7238576 13.7238576,16.5 14,16.5 L14,16.5 L16.9999242,16.5 L17,13.5 C17,13.2545401 17.1768752,13.0503916 17.4101244,13.0080557 Z M11.5,2 C14.2614237,2 16.5,4.23857625 16.5,7 C16.5,9.76142375 14.2614237,12 11.5,12 C8.73857625,12 6.5,9.76142375 6.5,7 C6.5,4.23857625 8.73857625,2 11.5,2 Z M11.5,3 C9.290861,3 7.5,4.790861 7.5,7 C7.5,9.209139 9.290861,11 11.5,11 C13.709139,11 15.5,9.209139 15.5,7 C15.5,4.790861 13.709139,3 11.5,3 Z"
          vector-effect="non-scaling-stroke"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "AddUserIcon",
  props: {
    color: {
      type: String,
      default() {
        return "#256AB3";
      },
    },
  },
};
</script>

<style scoped></style>
